import DOMPurify from "dompurify";

export interface UnsanitizedHtml {
  potentiallyDangerousHtml: string;
}

export interface SanitizedHtml {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- React dangerouslySetInnerHTML contract
  __html: string;
}

export interface SanitizeHtmlParams extends UnsanitizedHtml {
  config?: Parameters<typeof DOMPurify.sanitize>[1];
}

/**
 * Sanitizes HTML content using DOMPurify to prevent XSS attacks.
 * Returns an object that can be passed to React's dangerouslySetInnerHTML.
 *
 * @example
 * ```tsx
 * <div dangerouslySetInnerHTML={sanitizeHtml({ potentiallyDangerousHtml: knockBody })} />
 * ```
 */
export function sanitizeHtml(params: SanitizeHtmlParams): SanitizedHtml {
  const { potentiallyDangerousHtml, config } = params;

  return {
    __html: String(DOMPurify.sanitize(potentiallyDangerousHtml, config)),
  };
}
